import { render, staticRenderFns } from "./BarcodeIcon.vue?vue&type=template&id=f7b13fc2&"
import script from "./BarcodeIcon.vue?vue&type=script&lang=js&"
export * from "./BarcodeIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports